export const TEAM_REQUEST_DATA = 'TEAM/REQUEST_DATA';
export const RECEIVE_TEAMS = 'TEAM/RECEIVE_TEAMS';
export const TEAM_BEGIN_WRITE_DATA = 'TEAM/BEGIN_WRITE_DATA';
export const TEAM_COMPLETE_WRITE_DATA = 'TEAM/COMPLETE_WRITE_DATA';
